import { useRef, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  TextareaAutosize,
  Autocomplete,
  Tooltip
} from '@mui/material';
import { useTheme } from '@emotion/react';
// import { __APP_SHADOW_ROOT } from '..';

function FormFactory({ fields, terms, onSubmit }) {
  const $form = useRef();
  const theme = useTheme();

  const [termsChecked, setTermsChecked] = useState(false);  
  const [formValues, setFormValues] = useState(
    Object.keys(fields).reduce((acc, key) => { acc[key] = ''; return acc; }, {}) 
  );

  const handleInputChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.value
    });
  };

  const getSubmitDisabled = () => {
    // return false;
    const fieldsFilled = Object.entries(formValues).every(([key, value]) => {
      if (fields[key].required) {
        return value.trim() !== "";
      }
      return true;
    });
    return !termsChecked || !fieldsFilled;
  };

  const getFormObject = () => Object.keys(formValues).reduce((acc, key) => { 
    acc[key] = {
      label: fields[key].label || key,
      value: formValues[key],
      required: fields[key]?.required,
    };
    return acc; 
  }, {});

  const getSubmitInfo = () => {
    const fieldsFilled = Object.entries(formValues).map(([key, value]) => {
      if (fields[key].required && value.trim() === "") {
        return fields[key].label;
      }
      return false;
    }).filter(n => n);

    if (fieldsFilled.length > 0) {
      return `I seguenti campi sono obbligatori: ${fieldsFilled.join(', ')}`;
    }

    if (!termsChecked) {
      return 'Devi accettare i termini e le condizioni';
    }

    return null;
  }

  const renderField = (key, onChange) => {
    const fieldObject = fields[key];
    const title = fields[key].label || key;
    switch (fields[key].control) {
      case 'email':
        return (
          <Box mb={2} key={key}>
            <TextField
              label={title}
              type="email"
              id={key}
              required={fields[key].required}
              value={formValues[key]}
              onChange={onChange}
              fullWidth
            />
          </Box>
        );
      case 'text':
        return (
          <Box mb={2} key={key}>
            <TextField
              label={title}
              type="text"
              id={key}
              required={fields[key].required}
              value={formValues[key]}
              onChange={onChange}
              fullWidth
            />
          </Box>
        );
      case 'textarea':
        return (
          <Box mb={2} key={key}>
            <TextareaAutosize
              id={key}
              placeholder={title}
              value={formValues[key]}
              required={fields[key].required}
              onChange={onChange}
              style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
              minRows={3}
            />
          </Box>
        );
      case 'select':
        return (
          <Box mb={2} key={key}>
            <Autocomplete 
              id={key}
              required={fields[key].required}
              options={Object.keys(fields[key].choices).reduce((acc, countryCode) => { 
                acc.push({
                  label: fields[key].choices[countryCode],
                  value: countryCode,
                }) 
                return acc; 
              }, [])}
              slotProps={{
                popper: {
                  sx: {
                    zIndex: "9999999999 !important",
                    maxHeight: '50vh',
                  },
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return option.value === value.value;
              }}
              onChange={(event, newValue) => {
                console.log(newValue);
                onChange({ target: { id: key, value: newValue.value } });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={title + (fieldObject.required ? '*' : '')} 
                />
              )}
            />
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Box component={"form"} ref={$form} sx={{ p: theme => theme.spacing(2)}}>
      {Object.keys(fields).map((key) => renderField(key, handleInputChange))}
      <Box mb={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
            />
          }
          label={<span dangerouslySetInnerHTML={{ __html: terms }} />}
        />
      </Box>
      <Box mb={2}>
        <Tooltip
          title={getSubmitInfo()}
          placement='top'
        >
          <span>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={getSubmitDisabled()}
              onClick={(e) => {
                e.preventDefault();
                onSubmit($form.current, getFormObject());
              }}
              sx={{
                "&:not(.Mui-disabled)": {
                  color: theme.palette.primary.contrastText,
                }
              }}
            >
              Richiedi
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default FormFactory;